module.exports = __webpack_public_path__ + "static/media/gamepad.9bafcb79.svg";